import { moduleRequest } from '@/utils/request'

const request = moduleRequest(`/auth/c/`)
/**
 * 登录接口管理
 *
 */
export default {
	// C端获取赣通码
	getGtmQrCode(data) {
		return request('getGtmQrCode', data, 'get')
	},
	// C端赣通码扫码是否授权成功检测
	checkGtmLogin(data) {
		return request('checkGtmLogin', data, 'get')
	},
	// C端获取图片验证码
	getPicCaptcha(data) {
		return request('getPicCaptcha', data, 'get')
	},
	// C端获取手机验证码
	getPhoneValidCode(data) {
		return request('getPhoneValidCode', data, 'get')
	},
	// C端账号密码登录
	login(data) {
		return request('v1/doLogin', data, 'post', false)
	},
	// C端手机验证码登录
	loginByPhone(data) {
		return request('v1/doLoginByPhone', data, 'post', false)
	},
	mpLoginByPhone(data) {
		return request('doMpLoginByPhone', data, 'post', false)
	},
	// 退出
	logout(data) {
		return request('doLogout', data, 'get')
	},
	// 获取用户信息
	getLoginUser(data) {
		return request('getLoginUser', data, 'get')
	}
}
